module.exports = __webpack_public_path__ + "static/RR3-a779846b5913fefc20640a8f6392d16a.jpg";